export function Placeholder({ label = "Emplacement photo", caption, className = "", dark = false, testid, src, alt, position = "center" }) {
  if (src) {
    return (
      <figure data-testid={testid} className={`relative overflow-hidden ${className}`}>
        <img src={src} alt={alt || caption || label} loading="lazy" className="absolute inset-0 w-full h-full object-cover" style={{ objectPosition: position }} />
        {caption && <figcaption className="absolute left-5 bottom-5 bg-[#1C1917]/70 text-[#FBF9F5] font-display italic text-sm px-3 py-1.5">{caption}</figcaption>}
      </figure>
    );
  }
  return (
    <div data-testid={testid} role="img" aria-label={`${label}${caption ? " — " + caption : ""}`}
      className={`relative overflow-hidden ${dark ? "k-weave-dark text-[#FBF9F5]" : "k-weave text-[#1C1917]"} ${className}`}>
      <div className="absolute inset-3 sm:inset-4 k-stitch" style={dark ? { borderColor: "rgba(251,249,245,.25)" } : undefined} />
      <svg className="absolute right-6 bottom-6 w-16 h-16 opacity-25" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.2" aria-hidden>
        <circle cx="32" cy="32" r="22" /><path d="M14 32h36M32 14v36" strokeDasharray="2 3" /><circle cx="32" cy="32" r="6" />
      </svg>
      <div className="absolute left-6 top-6 sm:left-8 sm:top-8 max-w-[75%]">
        <span className="font-mono-k text-[10px] tracking-[0.2em] uppercase opacity-70">{label}</span>
        {caption && <p className="font-display italic text-lg mt-1 opacity-80">{caption}</p>}
      </div>
    </div>
  );
}
